import classNames from 'classnames'
import { useCallback, useMemo, useState } from 'react'

import { Loader } from 'core-components/library/loader'
import { IWidget } from 'core-components/sitebuilder/models/IWidget'

import styles from './IFrame.module.scss'

export interface IProps {
  className?: string
  widget: IWidget
  iframeUrl?: string
  onLoad?: () => void
}

export const IFrame = ({ widget, className, iframeUrl, onLoad }: IProps) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(false)

  const onIframeLoad = useCallback(() => {
    setIsLoaded(true)
    if (onLoad) {
      onLoad()
    }
  }, [onLoad])

  const iframeSrc = useMemo(() => {
    return iframeUrl || widget.src
  }, [iframeUrl, widget.src])

  if (!iframeSrc) {
    return null
  }

  return (
    <div className={styles.root}>
      <iframe
        key={widget.viewModel}
        title={`${widget.title}-${widget.i}`}
        id={'iframe'}
        src={iframeSrc}
        className={classNames(styles.iframe, className || '')}
        style={{ width: '100%', height: '100%' }}
        onLoad={() => onIframeLoad()}
      />
      {isLoaded || <Loader className={styles.loader} />}
    </div>
  )
}
